import { AavoButtonProps } from "src/components/common/buttons/AavoButton.tsx";
import { useOpenLegacyView } from "src/components/views/legacy/hooks.ts";
import i18n from "i18next";
import { openLegacyCustomerOrderView } from "src/components/views/legacy/legacyViewAdapters.ts";
import { faFileInvoiceDollar } from "@fortawesome/pro-regular-svg-icons";
import { AsyncButtonContextMenuItem } from "src/components/common/contextMenu/AsyncButtonContextMenuItem.tsx";
import { useTenantCustomizations } from "src/tenantCustomizations/useTenantCustomizations.tsx";
import { ValueOrProvider, resolveValueOrProvider } from "src/utils/valueOrProvider.ts";

export interface OpenCustomerOrderButtonProps extends Omit<AavoButtonProps, "onClick"> {
	customerOrderId: ValueOrProvider<number>;
}

export const OpenCustomerOrderContextMenuButton = ({
	customerOrderId: customerOrderIdOrProvider,
}: OpenCustomerOrderButtonProps) => {
	const openLegacyView = useOpenLegacyView();

	const { tenantConfig } = useTenantCustomizations();
	if (!tenantConfig.erp.salesEnabled) return null;

	return (
		<AsyncButtonContextMenuItem
			label={i18n.t("open_customer_order")}
			icon={faFileInvoiceDollar}
			onClick={() => {
				const customerOrderId = resolveValueOrProvider(customerOrderIdOrProvider);
				openLegacyCustomerOrderView(openLegacyView, customerOrderId);
			}}
		/>
	);
};
